import { render, staticRenderFns } from "./CommissionsGenericList.vue?vue&type=template&id=7de51c1a&scoped=true&"
import script from "./CommissionsGenericList.vue?vue&type=script&lang=js&"
export * from "./CommissionsGenericList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de51c1a",
  null
  
)

export default component.exports